import React, { useState, useEffect } from 'react';
import { Button, Alert, Row, Col, Form } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import ProductList from '../components/ProductList.tsx';
import { useCanvaAuth } from '../contexts/CanvaAuthContext2.tsx';
import GiftModal from '../components/GiftModal.tsx';



// Load the publishable key from your environment

const CanvaPurchase = () => {
  const [products, setProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [error, setError] = useState(null);
  
  const { canvaAuthenticated } = useCanvaAuth();
  const location = useLocation();
  const isUpgrade = location.pathname.includes("upgrade");
  const [showGiftModal, setShowGiftModal] = useState(false);
  const [billingPeriod, setBillingPeriod] = useState<'monthly' | 'annual'>('monthly');
  const isPricingTest = canvaAuthenticated?.userProfile?.pricingTest === true;

  useEffect(() => {
    if (canvaAuthenticated?.userProfile?.gift) {
      setShowGiftModal(true);
    }
  }, [canvaAuthenticated]);

  return (
    <>
      <Helmet>
        <title>AI Music by Muzaic</title>
      </Helmet>
      
      {canvaAuthenticated && (
        <>
          {/* Home Button - absolute positioned top left - only for pricing test users */}
          {isPricingTest && (
            <Button
              variant="light"
              className="go-back-btn"
              onClick={() => window.location.href = 'https://muzaic.ai'}
            >
              <i className="bi bi-house me-2"></i>
              {canvaAuthenticated.env.strings['app-go-back-btn'] || 'app-go-back-btn'}
            </Button>
          )}
          
          <h1 className="text-white text-center mb-5 mt-5">{isUpgrade ? (canvaAuthenticated.env.strings['app-product-list-title-test-upgrade'] || 'app-product-list-title-test-upgrade') : (canvaAuthenticated.env.strings['app-product-list-title-test-manage'] || 'app-product-list-title-test-manage')}</h1>
          
          {/* Annual/Monthly Toggle - only show if pricingTest is true */}
          {isPricingTest && (
            <div className="text-center d-flex justify-content-center align-items-center">
              <div className="billing-label-container">
                <span className={`text-white ${billingPeriod === 'monthly' ? 'fw-bold' : ''}`}>
                  {canvaAuthenticated.env.strings['app-product-list-billing-monthly'] || 'app-product-list-billing-monthly'}
                </span>
              </div>
              <Form.Check
                type="switch"
                id="billing-period-switch"
                checked={billingPeriod === 'annual'}
                onChange={(e) => setBillingPeriod(e.target.checked ? 'annual' : 'monthly')}
                className="custom-switch"
              />
              <div className="billing-label-container">
                <span className={`text-white ${billingPeriod === 'annual' ? 'fw-bold' : ''}`}>
                  {canvaAuthenticated.env.strings['app-product-list-billing-annual'] || 'app-product-list-billing-annual'}
                </span>
              </div>
            </div>
          )}
          
          <ProductList billingPeriod={billingPeriod} />
          <div className="text-white text-center mt-8">
          © Muzaic 2025 <br></br><a className="text-decoration-none" href="https://muzaic.ai/terms-of-use" target="_blank"> {canvaAuthenticated.env.strings['app-link-terms-of-use'] || 'app-link-terms-of-use'}</a>
          </div>
        </>
      )}
      
      <GiftModal show={showGiftModal} onClose={() => setShowGiftModal(false)} />

      
    </>
  );
};

export default CanvaPurchase;
